export default function SuitableCompanies() {
  const criteria = [
    { icon: 'ri-line-chart-line', title: 'Компания активно растёт', desc: 'Выручка, штат и количество клиентов увеличиваются — команда не успевает адаптироваться к новым масштабам управления.' },
    { icon: 'ri-user-add-line', title: 'Появляются новые руководители', desc: 'Сотрудников повышают до управленческих позиций, но они не готовы к новой роли и совершают типичные ошибки.' },
    { icon: 'ri-building-2-line', title: 'Развивается филиальная сеть', desc: 'Открываются новые офисы и представительства — нужно выстроить единую систему управления в разных локациях.' },
    { icon: 'ri-computer-line', title: 'Внедряется CRM или ERP', desc: 'Новые технологии требуют изменения процессов и перестройки управленческих подходов на всех уровнях.' },
    { icon: 'ri-refresh-line', title: 'Меняются бизнес-процессы', desc: 'Компания трансформируется — руководители должны управлять изменениями, а не сопротивляться им.' },
    { icon: 'ri-flag-2-line', title: 'Строится корпоративная культура', desc: 'Формирование ценностей, стандартов поведения и единой управленческой философии требует обучения лидеров.' },
    { icon: 'ri-rocket-2-line', title: 'Компания масштабируется', desc: 'Переход от малого бизнеса к среднему или от среднего к крупному требует иного уровня управления.' },
    { icon: 'ri-user-star-line', title: 'Собственник хочет выйти из операционки', desc: 'Передача управления наёмным руководителям требует выстроенной системы и подготовленных управленцев.' },
  ];

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Для каких компаний подходит обучение руководителей
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Тренинг для руководителей особенно эффективен, когда компания проходит через изменения и рост
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {criteria.map((item, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-3xl mx-auto bg-teal-50 border border-teal-200 rounded-xl p-6 md:p-8 text-center">
          <p className="text-teal-800 font-semibold text-base md:text-lg">
            Если ваша компания соответствует хотя бы двум критериям — системное обучение руководителей даст измеримый бизнес-результат в течение 3–6 месяцев.
          </p>
        </div>
      </div>
    </section>
  );
}